module.exports = __webpack_public_path__ + "static/img/Galaxy_Watch_Gear_S4_LTE.224188cf.jpg";